var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"DaStudent"}},[_c('div',{ref:"userOver",staticStyle:{"height":"150px"}}),_c('div',{ref:"getUserYearForGard",staticStyle:{"height":"400px"}}),_c('div',{ref:"getUserYear",staticStyle:{"height":"400px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }